class MobileMenu {
  constructor() {
    this.html = document.querySelector('html')
    this.menu = document.querySelector(".mobile-menu")
    this.openButton = document.querySelector(".site-header__menu-trigger")
    this.mobileMenuItems = document.querySelectorAll(".mobile-menu__title")
    this.events()

  }

  events() {
    this.openButton.addEventListener("click", () => this.openMenu())
    this.openMobileMenuItem()

  }

  openMobileMenuItem(event) {
    let that = this
    for (var z = 0; z < this.mobileMenuItems.length; z++) {
        this.mobileMenuItems[z].addEventListener("click", function (event) {
            this.classList.toggle('mobile-menu-item--open')
          })
    }


  }
  openMenu() {
    this.openButton.classList.toggle("icon-hamburger")
    this.openButton.classList.toggle("icon-close")
    this.menu.classList.toggle("mobile-menu--active")

    this.html.classList.toggle('mobile-menu--open')
  }
}

export default MobileMenu
